import {
  MODIFICATION_TYPE_LIST,
  PUJA_ORDER_STATUS,
  PUJA_STATUS_LIST,
  ORDERTYPE_PAYMENT_STATUS,
  orderType,
} from "../../utils/Constants";
import {
  setLoading,
  setOrderList,
  setUserOrderList,
  setUserDonationList,
} from "./../slices/orderSlice";

import { OrderService, CommonService } from "td_server/services";
import { getDateNowInUtc } from "../../utils/HelperFunctions";
import { emptyCartAction } from "./cartAction";
import { trackedAsync } from "../../utils/analyics/trackedAsync";
export const placeOrderAction =
  (
    cartInfo: any,
    userInfo: any,
    address: any = null,
    finalPrice: any,
    transectionId: any,
    orderId: any,
    razorpayPaymentId: any,
    priceBreakup: any,
    isPrasad: boolean = false,
    isOverseas: boolean = false,
    rate = 1,
    currencySymbols = "₹",
    currencyCode = "INR",
    orderValueOv = null,
    couponData:any =  null,
    deviceDetails:any= null,
    paymentMethod: any = "CARD",
  ) =>
  async (dispatch: any) => {
    try {
      let prasadOrChadhavaList = [];
      if (cartInfo[0]?.orderType === orderType.chadhava) {
        prasadOrChadhavaList = cartInfo[0]?.selectedChadhavaPackage || [];
        if (cartInfo[0]?.isSubscribed) {
          prasadOrChadhavaList = cartInfo[0]?.subscriptionChadhavas || [];
        }
      }
      if (cartInfo[0]?.orderType === orderType.prasad) {
        prasadOrChadhavaList = cartInfo[0]?.selectedPrasadPackage || [];
      }
      dispatch(setLoading(true));
      const orderData = {
        orderId: orderId,
        pujaId: cartInfo[0]?.pujaDetails
          ? cartInfo[0]?.pujaDetails?.pujaId ?? cartInfo[0]?.pujaDetails?.id
          : "",
        pujaName: cartInfo[0]?.pujaDetails
          ? cartInfo[0]?.pujaDetails?.pujaName
          : "",
        templeId: cartInfo[0]?.templeDetails?.id,
        pujaDate: `${cartInfo[0]?.bookedForDate?.pujaDate}`,
        pujaDetails: cartInfo[0]?.pujaDetails || null,
        pujaPackage: cartInfo[0]?.pujaPackage,
        whatsAppNumber: cartInfo[0]?.whatsAppNumber,
        whatsAppNumberdialCode: cartInfo[0]?.whatsAppNumberdialCode,
        whatsAppCountryCode: cartInfo[0]?.whatsAppCountryCode,
        deviceDetails : deviceDetails,
        ...([orderType.chadhavaPackage, orderType.pujaPackage, orderType.chadhava, orderType.puja].includes(
          cartInfo[0]?.orderType
        )
          ? {
              isSubscribed: cartInfo[0]?.isSubscribed ?? false,
              subscriptionId: cartInfo[0]?.subscriptionId ?? null,
            }
          : {}),
        subscriptionPlan: cartInfo[0]?.currentSubscriptionPlan ?? null,
        deviceType: "WEB",
        orderType: cartInfo[0]?.orderType,
        chadhavaList: prasadOrChadhavaList,
        ...([orderType.puja, orderType.prasad, orderType.chadhava].includes(
          cartInfo[0]?.orderType
        )
          ? {
              templeDetails: {
                address: cartInfo[0]?.templeDetails?.personalInfo?.address,
                name: cartInfo[0]?.templeDetails?.personalInfo?.name,
                phoneNumber:
                  cartInfo[0]?.templeDetails?.personalInfo?.phoneNumber,
                admin: cartInfo[0]?.templeDetails?.selectedAdminList,
              },
            }
          : {}),
        orderUserDetails: {
          orderUserName: `${userInfo?.personalInfo?.firstName} ${userInfo?.personalInfo?.lastName}`,
          orderUserId: userInfo?.id,
          phoneNumber: userInfo?.phoneNumber,
          email: userInfo?.personalInfo?.email,
          numberOfHeadCount: cartInfo[0]?.membersData?.length,
          gender: userInfo?.personalInfo?.gender,
          groupDetails: cartInfo[0]?.membersData,
        },
        deliveryAddress: address,
        orderData: {
          isPrasad,
          isOverseas,
          rate,
          currencySymbols,
          currencyCode,
          priceBreakup: priceBreakup,
          orderDateTime: getDateNowInUtc(),
          payment: {
            orderValue: finalPrice,
            orderValueOv: orderValueOv,
            paymentMode: "CARD",
            paymentStatus: ORDERTYPE_PAYMENT_STATUS.INPROGRESS,
            paymentDateTime: getDateNowInUtc(),
            transactionId: transectionId,
            razorpayPaymentId: razorpayPaymentId,
            paymentId: paymentMethod,
            couponCode: couponData ,
          },
          multimediaLink: "",
          ...(cartInfo[0]?.orderType === orderType.prasad &&
            cartInfo[0]?.priceInfo?.delivaryWeightGrams >= 0 && {
              deliveryWeightGrams: cartInfo[0].priceInfo.delivaryWeightGrams,
            }),
          ...(cartInfo[0]?.orderType === orderType.prasad &&
            cartInfo[0]?.priceInfo?.delivaryWeightMl >= 0 && {
              delivaryWeightMl: cartInfo[0].priceInfo.delivaryWeightMl,
            }),
        },
        orderStatus: [
          {
            orderStatus: PUJA_ORDER_STATUS.PENDING,
            dateTime: getDateNowInUtc(),
            modifiedBy: {
              phoneNumber: userInfo.phoneNumber,
              isUser: true,
              name: `${userInfo.personalInfo.firstName} ${userInfo.personalInfo.lastName}`,
            },
          },
        ],
      };
      const docId = await trackedAsync(()=>OrderService.createOrder(orderData));
      dispatch(setLoading(false));

      dispatch(setOrderList([]));
      return Promise.resolve(docId);
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const addDonationInfoAction =
  (formData: any, templeDetails: any, userInfo: any, transectionId: any) =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const data = {
        ...formData,
        templeId: templeDetails.id,
        userId: userInfo.id,
        transectionId: transectionId,
        paymentStatus: "pending",
        templeDetails: {
          address: templeDetails.personalInfo.address,
          name: templeDetails.personalInfo.name,
          phoneNumber: templeDetails.personalInfo.phoneNumber,
        },
      };
      const orderId = await OrderService.addDonationInformation(data);
      dispatch(setLoading(false));
      return Promise.resolve(orderId);
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getUserOrder = (userInfo: any) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    let userOrderList;
    if (userInfo?.id) {
      userOrderList = await OrderService.getOrderOfUser(userInfo.id);
      dispatch(setUserOrderList(userOrderList));
    }

    dispatch(setLoading(false));
    return Promise.resolve(userOrderList);
  } catch (error: any) {
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const getAllOrder =
  (pageSize: any, pageNumber: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const userOrderList = await OrderService.getAllOrders(1000, 10);
      dispatch(setLoading(false));
      dispatch(setUserOrderList(userOrderList));
      return Promise.resolve(userOrderList);
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getAllOrderByDateRange =
  (dateRange: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const userOrderList = await OrderService.getAllOrderByDateRange(
        dateRange,
        "orderBookingDate"
      );
      dispatch(setLoading(false));
      dispatch(setUserOrderList(userOrderList));
      return Promise.resolve(userOrderList);
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getUserDonation = (userInfo: any) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const userDonationList = await OrderService.getDonationOfUser(userInfo.id);
    dispatch(setLoading(false));
    dispatch(setUserDonationList(userDonationList));
    const userOrderList = await OrderService.getAllOrders(0, 100);
    dispatch(setLoading(false));
    dispatch(setUserOrderList(userOrderList));
    return Promise.resolve(userDonationList);
  } catch (error: any) {
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const updateOrderStatusAction =
  (formData: any, orderId: any, dateRange: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      if (formData.modificationType === MODIFICATION_TYPE_LIST[0]) {
        formData.orderStatus = formData.pujaStatus;
      }
      if (formData.modificationType === MODIFICATION_TYPE_LIST[1]) {
        formData.orderStatus = formData.deliveryStatus;
      }
      const status = await OrderService.updateSingleOrderStatus(
        formData,
        orderId
      );
      getAllOrderByDateRange(dateRange);
      dispatch(setLoading(false));
      return Promise.resolve(status);
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const confirmedOrderStatusAction =
  (formData: any, orderId: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const data = formData;
      data.orderStatus = formData.pujaStatus;
      const status = await OrderService.updateSingleOrderStatus(data, orderId);

      return Promise.resolve(status);
    } catch (error: any) {
      return Promise.reject("");
    }
  };

export const getInVoicePdfUrl = (playload: any) => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const pdfData = await trackedAsync(()=>OrderService.downloadInvoice(playload));
    dispatch(setLoading(false));
    return Promise.resolve(pdfData);
  } catch (error: any) {
    dispatch(setLoading(false));
    return Promise.reject("");
  }
};

export const generateRazorPayOrderId =
  (orderData: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const razorPayresponse = await trackedAsync(()=>CommonService.generateRazorPayOrderId(
        orderData
      ));
      dispatch(setLoading(false));
      return Promise.resolve(razorPayresponse);
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject(error);
    }
  };

export const getSubOrdersOfaOrderAction =
  (idOfOrder: any) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const subOrdersList = await trackedAsync(()=>OrderService.getSubOrdersOfaOrder(idOfOrder));
      dispatch(setLoading(false));
      return Promise.resolve(subOrdersList);
    } catch (error: any) {
      dispatch(setLoading(false));
      return Promise.reject(
        `Failed to fetch sub-orders for order ID ${idOfOrder}`
      );
    }
  };
